import { render, staticRenderFns } from "./CreateGoods.vue?vue&type=template&id=5c8cb7f6&scoped=true&"
import script from "./CreateGoods.vue?vue&type=script&lang=js&"
export * from "./CreateGoods.vue?vue&type=script&lang=js&"
import style0 from "./CreateGoods.vue?vue&type=style&index=0&id=5c8cb7f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8cb7f6",
  null
  
)

export default component.exports